import {environment} from '../../environments/environment'
import {
  Configuration,
  Dimensions,
  OnEndActions,
  Overlay,
  OverlayImage,
  OverlayMix,
  OverlayText,
  Section,
  Video
} from './types'

const PROPORTION_START_IMG = 0.27
const PROPORTION_START_OPTION = 0.03
const PROPORTION_START_TEXT = 0.0165
const PROPORTION_ROOM_TITLE = 0.06
const PROPORTION_ROOM_HOME = 0.03
const PROPORTION_ROOM_OPTION = 0.023
const PROPORTION_BUTTON_ORDER = 0.2
const POS_Y_START_OPTION = 52.37
const POS_X_ROOM_OPTION = 70
const POS_X_ROOM_OPTION_MOODI = 75
const POS_X_ROOM_OPTION_BUTTON = POS_X_ROOM_OPTION + 0.7
const POS_X_ROOM_OPTION_BUTTON_MOODI = POS_X_ROOM_OPTION_MOODI + 0.7
const POS_Y_INIT_ROOM_OPTION = 20
const POS_Y_INTERVAL_ROOM_OPTION = 9
const POS_X_ROOM_TITLE = 10
const POS_Y_ROOM_TITLE = 20
const POS_X_ROOM_HOME = 94
const POS_Y_ROOM_HOME = 90

export const VideoDemoConfiguration = new Configuration(
  new Dimensions(1920, 1080),
  'Zweed_navigation_start.jpg',
  new Overlay([
    new OverlayImage({
      id: 'logo',
      posX: 50,
      posY: 15,
      align: 'center',
      proportion: PROPORTION_START_IMG,
      img: 'zweed_log_black.png'
    }),
    new OverlayText({
      id: 'text',
      posX: 50,
      posY: 32,
      align: 'center',
      proportion: PROPORTION_START_TEXT,
      text: 'Welcome to the Zweed family, please choose one of the products below and get to know us closer. A common trait they share is the blend between genuine functionality and a unique character, rooted in our Scandinavian heritage.',
      type: 'text'
    }),
    new OverlayMix({
        id: 'peep',
        posX: 19,
        posY: POS_Y_START_OPTION,
        align: 'top',
        videoId: 'peep_overview',
      },
      {img: 'Zweed_start_peep.jpg', proportion: 0.260416},//0.4074},
      {
        text: 'Peep',
        type: 'option',
        proportion: PROPORTION_START_OPTION
      }
    ),
    new OverlayMix({
        id: 'moodi',
        posX: 51.7,
        align: 'top',
        posY: POS_Y_START_OPTION,
        videoId: 'moodi_overview',
      },
      {img: 'Zweed_start_moodi.jpg', proportion: 0.338541},//0.4074},
      {
        text: 'Moodi',
        type: 'option',
        proportion: PROPORTION_START_OPTION
      }
    ),
    new OverlayMix({
        id: 'mino',
        posX: 82.6,
        align: 'top',
        posY: POS_Y_START_OPTION,
        videoId: 'mino_overview',
      },
      {img: 'Zweed_start_mino.jpg', proportion: 0.221354},// 0.4074},//0.3935},
      {
        text: 'Mino',
        type: 'option',
        proportion: PROPORTION_START_OPTION
      }
    )
  ]),
  [
    ////////////////////////////////////////////////////////////
    // PEEP VIDEOS
    ////////////////////////////////////////////////////////////
    new Video(
      'peep_overview',
      'ZWEED_Peep_overview.mp4',
      new Overlay(
        [
          new OverlayText({
            id: 'peep_title',
            posX: POS_X_ROOM_TITLE,
            posY: POS_Y_ROOM_TITLE,
            proportion: PROPORTION_ROOM_TITLE,
            text: 'PEEP',
            align: 'left',
            type: 'title'
          }),
          new OverlayText({
            id: 'peep_home',
            posX: POS_X_ROOM_HOME,
            posY: POS_Y_ROOM_HOME,
            proportion: PROPORTION_ROOM_HOME,
            section: 'home',
            text: 'HOME',
            align: 'right',
            type: 'title'
          }),
          new OverlayText({
            id: 'peep_overview',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'peep_overview',
            text: 'Overview',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'peep_design',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION + POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'peep_design',
            text: 'Features / Design',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'peep_specs',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION + 2 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'peep_specs',
            text: 'Specifications',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'peep_brochure',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION + 3.5 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            link: environment.bucketUrlDocs + 'Zweed_broschyr.pdf',
            text: 'Brochure',
            align: 'left',
            type: 'option'
          }),
          new OverlayImage({
            id: 'peep_order',
            posX: POS_X_ROOM_OPTION_BUTTON,
            posY: POS_Y_INIT_ROOM_OPTION + 4.5 * POS_Y_INTERVAL_ROOM_OPTION,
            align: 'left',
            proportion: PROPORTION_BUTTON_ORDER,
            img: 'Button_order.png',
            link: 'https://zweed.se/products/peep-b1',
          })
        ],
        'Zweed_Room_peep.jpg'
      ),
      'peep',
      OnEndActions.openOverlay()
    ),
    new Video(
      'peep_specs',
      'ZWEED_Peep_specs.mp4',
      new Overlay(),
      'peep',
      OnEndActions.goToSection('peep')
    ),
    new Video(
      'peep_design',
      'ZWEED_PEEP_Feature-design.mp4',
      new Overlay(),
      'peep',
      OnEndActions.goToSection('peep')
    ),
    ////////////////////////////////////////////////////////////
    // MOODI VIDEOS
    ////////////////////////////////////////////////////////////
    new Video(
      'moodi_overview',
      'ZWEED_Moodi_overview.mp4',
      new Overlay(
        [
          new OverlayText({
            id: 'moodi_title',
            posX: POS_X_ROOM_TITLE,
            posY: POS_Y_ROOM_TITLE,
            proportion: PROPORTION_ROOM_TITLE,
            text: 'MOODI',
            align: 'left',
            type: 'title'
          }),
          new OverlayText({
            id: 'moodi_home',
            posX: POS_X_ROOM_HOME,
            posY: POS_Y_ROOM_HOME,
            proportion: PROPORTION_ROOM_HOME,
            section: 'home',
            text: 'HOME',
            align: 'right',
            type: 'title'
          }),
          new OverlayText({
            id: 'moodi_overview',
            posX: POS_X_ROOM_OPTION_MOODI,
            posY: POS_Y_INIT_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'moodi_overview',
            text: 'Overview',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'moodi_features',
            posX: POS_X_ROOM_OPTION_MOODI,
            posY: POS_Y_INIT_ROOM_OPTION + POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'moodi_features',
            text: 'Features',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'moodi_design',
            posX: POS_X_ROOM_OPTION_MOODI,
            posY: POS_Y_INIT_ROOM_OPTION + 2 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'moodi_design',
            text: 'Design',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'moodi_specs',
            posX: POS_X_ROOM_OPTION_MOODI,
            posY: POS_Y_INIT_ROOM_OPTION + 3 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'moodi_specs',
            text: 'Specifications',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'moodi_brochure',
            posX: POS_X_ROOM_OPTION_MOODI,
            posY: POS_Y_INIT_ROOM_OPTION + 4.5 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            link: environment.bucketUrlDocs + 'Zweed_broschyr.pdf',
            text: 'Brochure',
            align: 'left',
            type: 'option'
          }),
          new OverlayImage({
            id: 'moodi_order',
            posX: POS_X_ROOM_OPTION_BUTTON_MOODI,
            posY: POS_Y_INIT_ROOM_OPTION + 5.5 * POS_Y_INTERVAL_ROOM_OPTION,
            align: 'left',
            proportion: PROPORTION_BUTTON_ORDER,
            img: 'Button_order.png',
            link: 'https://zweed.se/products/moodi-180',
          })
        ],
        'Zweed_Room_moodi.jpg'
      ),
      'moodi',
      OnEndActions.openOverlay()
    ),
    new Video(
      'moodi_features',
      'ZWEED_Moodi_features.mp4',
      new Overlay(),
      'moodi',
      OnEndActions.goToSection('moodi')
    ),
    new Video(
      'moodi_specs',
      'ZWEED_Moodi_specs.mp4',
      new Overlay(),
      'moodi',
      OnEndActions.goToSection('moodi')
    ),
    new Video(
      'moodi_design',
      'ZWEED_Moodi_Design.mp4',
      new Overlay(),
      'moodi',
      OnEndActions.goToSection('moodi')
    ),
    ////////////////////////////////////////////////////////////
    // MINO VIDEOS
    ////////////////////////////////////////////////////////////
    new Video(
      'mino_overview',
      'ZWEED_Mino_overview.mp4',
      new Overlay(
        [
          new OverlayText({
            id: 'mino_title',
            posX: POS_X_ROOM_TITLE,
            posY: POS_Y_ROOM_TITLE,
            proportion: PROPORTION_ROOM_TITLE,
            text: 'MINO',
            align: 'left',
            type: 'title'
          }),
          new OverlayText({
            id: 'mino_home',
            posX: POS_X_ROOM_HOME,
            posY: POS_Y_ROOM_HOME,
            proportion: PROPORTION_ROOM_HOME,
            section: 'home',
            text: 'HOME',
            align: 'right',
            type: 'title'
          }),
          new OverlayText({
            id: 'mino_overview',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'mino_overview',
            text: 'Overview',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'mino_montering',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION + POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'mino_montering',
            text: 'Montering',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'mino_design',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION + 2 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'mino_design',
            text: 'Features / Design',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'mino_specs',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION + 3 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            videoId: 'mino_specs',
            text: 'Specifications',
            align: 'left',
            type: 'option'
          }),
          new OverlayText({
            id: 'mino_brochure',
            posX: POS_X_ROOM_OPTION,
            posY: POS_Y_INIT_ROOM_OPTION + 4.5 * POS_Y_INTERVAL_ROOM_OPTION,
            proportion: PROPORTION_ROOM_OPTION,
            link: environment.bucketUrlDocs + 'Zweed_broschyr.pdf',
            text: 'Brochure',
            align: 'left',
            type: 'option'
          }),
          new OverlayImage({
            id: 'mino_order',
            posX: POS_X_ROOM_OPTION_BUTTON,
            posY: POS_Y_INIT_ROOM_OPTION + 5.5 * POS_Y_INTERVAL_ROOM_OPTION,
            align: 'left',
            proportion: PROPORTION_BUTTON_ORDER,
            img: 'Button_order.png',
            link: 'https://zweed.se/products/mino-large',
          })
        ],
        'Zweed_Room_mino.jpg'
      ),
      'mino',
      OnEndActions.openOverlay()
    ),
    new Video(
      'mino_montering',
      'ZWEED_Mino_montering.mp4',
      new Overlay(),
      'mino',
      OnEndActions.goToSection('mino')
    ),
    new Video(
      'mino_specs',
      'ZWEED_Mino_specs.mp4',
      new Overlay(),
      'mino',
      OnEndActions.goToSection('mino')
    ),
    new Video(
      'mino_design',
      'ZWEED_MINO-Feature-design.mp4',
      new Overlay(),
      'mino',
      OnEndActions.goToSection('mino')
    )
  ],
  [
    new Section(
      'home',
      'Home',
      '',
      ['home', 'mino', 'moodi', 'peep']
    ),
    new Section(
      'mino',
      'Mino',
      '',
      ['home', 'mino'],
      false
    ),
    new Section(
      'moodi',
      'Moodi',
      '',
      ['home', 'moodi'],
      false
    ),
    new Section(
      'peep',
      'Peep',
      '',
      ['home', 'peep'],
      false
    )
  ]
)